import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import Image from 'next/image'
import React from 'react'

interface ProductGalleryNavigationProps {
  scrollPrev: () => void
  canScrollPrev: boolean
  canScrollNext: boolean
  scrollNext: () => void
  className?: string
}

const ProductGalleryNavigation: React.FC<ProductGalleryNavigationProps> = ({
  scrollPrev,
  canScrollPrev,
  canScrollNext,
  scrollNext,
  className,
}) => {
  return (
    <div className={cn('absolute right-4', className)}>
      <Button
        size='icon'
        onClick={scrollPrev}
        disabled={!canScrollPrev}
        variant='white'
        className='mr-2'
      >
        <Image
          alt='Icon prev'
          src='/icons/icon-arrow-line-right.svg'
          width={16}
          height={16}
          className='rotate-180 invert'
        />
      </Button>
      <Button
        size='icon'
        onClick={scrollNext}
        disabled={!canScrollNext}
        variant='white'
      >
        <Image
          alt='Icon prev'
          src='/icons/icon-arrow-line-right.svg'
          width={16}
          height={16}
          className='invert'
        />
      </Button>
    </div>
  )
}

export default ProductGalleryNavigation
